/**
 *  @class Cache class for managing the scan elements that manages localy stored data.
 */

import * as THREE from 'three';

import { MemoryManager } from '../memory-manager';
import { CacheElement } from './cache-element';

export default class PointcloudCache extends CacheElement {
  constructor(key: string, data: any, clearTimeout: number, clearCallback: any, size = 0) {
    super(key, data, clearTimeout, clearCallback, size, 'pointcloud');
  }

  dispose() {
    this.data.parent?.remove(this.data);

    if (this.data instanceof THREE.Mesh) {
      this.data.geometry.dispose();

      this.data.material.map?.dispose?.();
      this.data.material.dispose?.();
    }

    MemoryManager.getInstance().release(this.getSize(), this.type);
  }
}
